module.exports = __webpack_public_path__ + "static/media/search_ico.7e1fede5.svg";